import { useState, useEffect } from 'react';

let toastId = 0;

interface Toast {
  id: number;
  message: string;
  type: 'success' | 'error' | 'info';
}

const toastListeners: Array<(toast: Toast) => void> = [];

export function showToast(message: string, type: 'success' | 'error' | 'info' = 'success') {
  const toast: Toast = {
    id: toastId++,
    message,
    type,
  };
  
  toastListeners.forEach((listener) => listener(toast));
}

export function ToastContainer() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  useEffect(() => {
    const listener = (toast: Toast) => {
      setToasts((prev) => [...prev, toast]);
      
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== toast.id));
      }, 3000);
    };

    toastListeners.push(listener);

    return () => {
      const index = toastListeners.indexOf(listener);
      if (index > -1) {
        toastListeners.splice(index, 1);
      }
    };
  }, []);

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`
            px-6 py-4 rounded-lg shadow-lg flex items-center gap-3 min-w-[300px] max-w-md
            animate-[slideIn_0.3s_ease-out]
            ${toast.type === 'success' ? 'bg-teal-600 text-white' : ''}
            ${toast.type === 'error' ? 'bg-red-600 text-white' : ''}
            ${toast.type === 'info' ? 'bg-gray-800 text-white' : ''}
          `}
        >
          <div className="w-5 h-5 flex items-center justify-center">
            {toast.type === 'success' && <i className="ri-check-line text-xl"></i>}
            {toast.type === 'error' && <i className="ri-error-warning-line text-xl"></i>}
            {toast.type === 'info' && <i className="ri-information-line text-xl"></i>}
          </div>
          <p className="flex-1 text-sm font-medium">{toast.message}</p>
        </div>
      ))}
    </div>
  );
}
